// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"general_pageTitle__cc9PJ","ignoreSpacing":"general_ignoreSpacing__Hrupy"};